module.exports = __webpack_public_path__ + "img/si.63ba8c45.svg";